
// region JS Imports

// region External Modules
import $ from "jquery"
import Swiper from "swiper"

import {
  Autoplay,
  Pagination,
  Navigation,
} from "swiper/modules"
// endregion External Modules

// region Private Modules
import GA4_Event from "app/tracking/google/google_analytics_4/event"
import PageInstance from "app/page_instance"
import { q_ajax_3 } from "app/utils/q_ajax/q_ajax_3"

import * as Routes from "plugins/js-routes"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string

  agent_sections_swiper:          string
  agent_sections_swiper_wrapper:  string

  agent_section:             string
  handy_button:              string
  information_box_container: string
  information_box:           string

  phone_contact:      string
  whatsapp_contact:   string
}
interface InputSelector {
  scope?:              string

  agent_sections_swiper?:         string
  agent_sections_swiper_wrapper?: string

  agent_section?:             string
  handy_button?:              string
  information_box_container?: string
  information_box?:           string

  phone_contact?:      string
  whatsapp_contact?:   string
}

const default_selector = {
  scope: ".page--building-level-real-estate-transactions-page--agent_sections-container",

  agent_sections_swiper:          ".page--building-level-real-estate-transactions-page--agent_sections-swiper",
  agent_sections_swiper_wrapper:  ".page--building-level-real-estate-transactions-page--agent_sections-swiper-wrapper",

  agent_section:              ".page--building-level-real-estate-transactions-page--agent_section",
  handy_button:               ".page--building-level-real-estate-transactions-page--agency_contact_handy_button",
  information_box_container:  ".page--building-level-real-estate-transactions-page--agents_contact_information_box_container",
  information_box:            ".page--building-level-real-estate-transactions-page--agent_contact_information_box",

  phone_contact:    ".page--building-level-real-estate-transactions-page--agent_contact_phone_number",
  whatsapp_contact: ".page--building-level-real-estate-transactions-page--agent_contact_whatsapp_number",
}

enum ContactTypeEnums {
  HANDY_BUTTON = "whatsapp (learn more)",
  WEBSITE_URL  = "website url",
  PHONE        = "phone",
  WHATSAPP     = "whatsapp",
  SMS          = "sms",
}

class NewDevelopmentAgentSection {
  protected selector: Selector

  protected $scope: JQuery

  protected $agent_sections_swiper:         JQuery
  protected $agent_sections_swiper_wrapper: JQuery

  protected $agent_section:             JQuery
  protected $handy_button:              JQuery
  protected $information_box_container: JQuery
  protected $information_box:           JQuery

  protected $phone_contact:     JQuery
  protected $whatsapp_contact:  JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, default_selector, selector)
    this.$scope = $(this.selector.scope)

    this.$agent_sections_swiper = this.$scope.find(this.selector.agent_sections_swiper)
    this.$agent_sections_swiper_wrapper = this.$scope.find(this.selector.agent_sections_swiper_wrapper)

    this.$agent_section = this.$scope.find(this.selector.agent_section)
    this.$handy_button = this.$scope.find(this.selector.handy_button)
    this.$information_box_container = this.$scope.find(this.selector.information_box_container)
    this.$information_box = this.$scope.find(this.selector.information_box)

    this.$phone_contact = this.$scope.find(this.selector.phone_contact)
    this.$whatsapp_contact = this.$scope.find(this.selector.whatsapp_contact)

    this.created()
    this.bind_action()
  }

  protected created() {
    this.agent_section_element_shuffling()
    this.information_box_elements_shuffling()
    this.create_swiper_object()

    GA4_Event.track({
      event_name: "new_dev_agent_contact_displayed",
      options:    {
        page: PageInstance.currentPageNameForTracking(),
      },
    })

    this.$scope.addClass("js-spacious-initialized")
  }

  protected bind_action() {

    this.$agent_section.each((_idx, agent_section) => {
      const $current_handy_button = $(agent_section).find(this.selector.handy_button)

      if ( $current_handy_button.attr("link_to_external_page") === "true" ) {
        const web_url = $current_handy_button.attr("web_url") as string

        if ( web_url ) {
          $current_handy_button.addClass("show")

          $current_handy_button.on("click" ,() => {
            this.create_contact_event_record($current_handy_button, ContactTypeEnums.WEBSITE_URL)
            window.open(web_url)
          })
        }
      }
      else {
        const $first_whatsapp_contact = $(agent_section).find(this.selector.whatsapp_contact).first()

        if ( $first_whatsapp_contact.length > 0 ) {
          $current_handy_button.addClass("show")

          $current_handy_button.on("click" ,() => {
            this.create_whatsapp_link(($first_whatsapp_contact))
            this.create_contact_event_record($first_whatsapp_contact, ContactTypeEnums.HANDY_BUTTON)
          })
        }
      }
    })

    this.$phone_contact.on("click" ,(e) => {
      window.open(`tel:${$(e.currentTarget).attr("phone_number")}`)
      this.create_contact_event_record($(e.currentTarget), ContactTypeEnums.PHONE)
    })

    this.$whatsapp_contact.on("click" ,(e) => {
      this.create_whatsapp_link($(e.currentTarget))
      this.create_contact_event_record($(e.currentTarget), ContactTypeEnums.WHATSAPP)
    })

  }

  protected agent_section_element_shuffling() {
    const children_elements = this.$agent_sections_swiper_wrapper.children()
    while (children_elements.length) {
      this.$agent_sections_swiper_wrapper.append(children_elements.splice(Math.floor(Math.random() * children_elements.length), 1)[0])
    }
  }

  protected information_box_elements_shuffling() {
    this.$information_box_container.each((_idx, el) => {
      if ( $(el).attr("random_order") === "false") { return }

      const $current_information_box_container = $(el)

      const children_elements = $current_information_box_container.children()
      while (children_elements.length) {
        $current_information_box_container.append(children_elements.splice(Math.floor(Math.random() * children_elements.length), 1)[0])
      }
    })
  }

  protected create_swiper_object() {
    this.$agent_sections_swiper.each((idx, el) => {
      new Swiper($(el)[0] as HTMLElement, {
        modules:        [Autoplay, Navigation, Pagination],
        spaceBetween:   30,
        loop:           true,
        speed:          500,
        direction:      "horizontal",
        allowTouchMove: false,
        autoplay:       {
          delay:                10000,
          disableOnInteraction: false,
        },
      })
    })
  }

  protected create_whatsapp_link($current_element: JQuery<HTMLElement>) {
    const parsed_whatsapp_number = $current_element.attr("whatsapp_number")?.replace(/\D/g, "") as string
    const whatsapp_message = $current_element.attr("whatsapp_message")

    window.open(`https://wa.me/${parsed_whatsapp_number}?text=${whatsapp_message}`)
  }

  protected create_contact_event_record($current_element: JQuery<HTMLElement>, contact_type: string) {
    const real_estate_agent_building_relationship_record_id = $current_element.attr("record_id") as string

    q_ajax_3(
      {
        url:      Routes.create_api_web_app_real_estate_agent_building_relationship_contact_event_index_path(),
        method:   "POST",
        dataType: "json",
        data:     {
          real_estate_agent_building_relationship_record_id:  real_estate_agent_building_relationship_record_id,
          contact_type:                                       contact_type,
        },
      },
    )
  }

}

const Factory = {
  _instance: null as null | NewDevelopmentAgentSection,
  instance(){
    if (this._instance != null){
      return this._instance
    }
    this._instance = this.create()
    return this._instance
  },
  create(){
    return new NewDevelopmentAgentSection()
  },
}

export {
  Factory,
}
